import { ChatCircleDots } from '@phosphor-icons/react';

// Milestone 12 -- the one reusable "hand context to Talk to Martian"
// affordance (point 10: "Do not make this a separate page. Do not lose
// the current workspace."). Used from both a found-row and a
// prepared-work card rather than building two divergent entry points.
// Deliberately a plain tertiary text control -- never competing
// visually with the real primary/secondary decision actions
// (Review/Approve/Dismiss) on the same row.
export function AskMartianButton({ onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="ask-martian-button"
      className="inline-flex items-center gap-1 text-[11px] font-medium text-[var(--martian-ink-muted,var(--text-tertiary))] hover:text-[var(--martian-violet,var(--accent))]"
    >
      <ChatCircleDots size={11} />
      Ask Martian about this
    </button>
  );
}
